<template>
  <div>
    <b-form inline class="mb-2">
      <b-form-checkbox switch v-model="asked" :value="true" :unchecked-value="false" :disabled="disabled || notNullable" @input="onChange">
        <span v-html="label"></span>
        <small v-if="!!help" class="ml-1 text-muted" :title="help" v-b-tooltip.hover>
          <i class="fa fa-fw fa-info-circle"></i>
        </small>
      </b-form-checkbox>
      <b-form-input v-if="asked && name !== undefined" v-model="field" size="sm" class="ml-4" :placeholder="namePlaceholder || label" @input="onNameChange" :style="nameMinWidth ? `min-width: ${nameMinWidth}px;` : ''" />
      <b-form-radio-group v-if="asked && showOptions" v-model="required" size="sm" class="ml-4" :options="options" :disabled="disabled || notOptional || notRequired" @input="onChange"></b-form-radio-group>
    </b-form>
    <b-form-group v-if="asked && description !== undefined" class="ml-4">
      <b-form-input v-model="desc" size="sm" :placeholder="trans('description')" @input="onDescriptionChange" />
    </b-form-group>
  </div>
</template>

<script>
  export default {
    props: {
      value: String|Boolean, // null, optional, required
      label: String,
      name: String,
      description: String,
      notNullable: {
        type: Boolean,
        default: false,
      },
      showOptions: {
        type: Boolean,
        default: true,
      },
      notOptional: {
        type: Boolean,
        default: false,
      },
      notRequired: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      namePlaceholder: String,
      nameMinWidth: Number,
      help: String,
    },
    data() {
      return {
        trans: trans,
        asked: !!this.value || this.notNullable,
        field: this.name,
        desc: this.description,
        required: this.value || 'optional',
        options: [{
          value: 'optional',
          text: trans('optional'),
        }, {
          value: 'required',
          text: trans('required'),
        }],
      }
    },
    watch: {
      value() {
        this.asked = !!this.value || this.notNullable
        this.required = this.value || 'optional'
      },
      name() {
        this.field = this.name
      },
      description() {
        this.desc = this.description
      },
    },
    methods: {
      onChange() {
        if (this.asked && this.notRequired && this.required != 'optional') {
          this.required = 'optional'
        }
        if (this.asked && this.notOptional && this.required != 'required') {
          this.required = 'required'
        }
        this.$emit('input', this.asked ? this.required : null)
      },
      onNameChange() {
        this.$emit('name', this.field)
      },
      onDescriptionChange() {
        this.$emit('description', this.desc)
      },
    },
  }
</script>